import { render, staticRenderFns } from "./image-gradient.vue?vue&type=template&id=38b3d24a&"
import script from "./image-gradient.vue?vue&type=script&lang=js&"
export * from "./image-gradient.vue?vue&type=script&lang=js&"
import style0 from "./image-gradient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports